import { render, staticRenderFns } from "./ButtonWithMessage.vue?vue&type=template&id=0d76880d&"
import script from "./ButtonWithMessage.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports